import useDocumentTitle from "@/hooks/useDocumentTitle";
import { useForm, FormProvider } from 'react-hook-form';
import FormModal from '@/components/ui/FormModal';
import usePatientStore from '@patientMenu/hooks/usePatientStore.ts';
import RemovePatientForm from '@patientMenu/form/RemovePatientForm';
import { useNavigate } from 'react-router-dom';
import { useDeletePatients } from '@hooks/usePatient.ts';

export default function RemovePatient() {
  useDocumentTitle("Patients - Remove Patient(s)");
  const navigate = useNavigate();
  const { selectedPatients } = usePatientStore();

  const form = useForm();
  const patientMut = useDeletePatients();

  const onSubmit = () => {
    const patientIds = Array.from(selectedPatients);
    patientMut.mutate(patientIds, {
      onSuccess: () => {
        onClose();
      },
      onError: (error) => {
        console.error('Error removing patients:', error);
      },
    });
  };

  const onClose = () => {
    navigate(-1);
  };

  return (
    <FormProvider {...form}>
      <FormModal submitText="Remove" submitButton="destructive" onSubmit={form.handleSubmit(onSubmit)} onClose={onClose}>
        <RemovePatientForm />
      </FormModal>
    </FormProvider>
  );
}
